import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, CalendarHolidays, Resource } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  calendarHolidays: Identifiable<CalendarHolidays>;
  retrieveResourceCalendarHolidays(
    request: Boundaries["retrieveResourceCalendarHolidays"]["request"],
  ): void;
}

function useRetrieveResourceCalendarHolidays(
  resource: Identifiable<Resource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveResourceCalendarHolidaysRequestPending(resource),
    ),

    isRequestSuccess: useSelector(() =>
      selector.isRetrieveResourceCalendarHolidaysRequestSuccess(resource),
    ),

    isRequestFailure: useSelector(() =>
      selector.isRetrieveResourceCalendarHolidaysRequestFailure(resource),
    ),

    calendarHolidays: useSelector(() =>
      selector.getResourceCalendarHolidays(resource),
    ),
    retrieveResourceCalendarHolidays: core.retrieveResourceCalendarHolidays,
  };
}

export { useRetrieveResourceCalendarHolidays };
